export default __webpack_public_path__ + "static/data-visualization-290a2603aa93c102593fbb08779fe271.jpg";